export default __webpack_public_path__ + "static/media/Business-Intelligence ICON.8c12217d.png";